import React, {useState, useEffect} from "react";
import { Select } from '@mantine/core';

const SelectDirectoryComponent = ({data, selected, onSelection}) => {
    const [selectedAcctId, setSelectedAcctId] = useState(selected.id || '');
    const [selectedAccount, setSelectedAccount] = useState(selected.account || '');
    const [selectedDirectory, setSelectedDirectory] = useState(selected.directory || '');

    useEffect(() => {
        // update local state when selected changes
        setSelectedAccount(selected.account || '');
        setSelectedDirectory(selected.directory || '');
    }, [selected]);

    const handleAccountChange = (e) => {
        var account = data.find(item => item.account === e);
        console.log(`selected account: ${e}`, account);
        setSelectedAccount(e);
        setSelectedAcctId(account.id);
        setSelectedDirectory('');
        console.log({id: selectedAcctId, account: selectedAccount, directory: selectedDirectory});
    };

    const handleDirectoryChange = (e) => {  
        const value = e;
        setSelectedDirectory(value);
        if (value) {
            onSelection({id: selectedAcctId, account: selectedAccount,  directory: value}); 
        }
    };

    
    console.log('DBG', data);
    const directories = selectedAccount ? data.find(item => item.account === selectedAccount).directories : [];
    console.log('directories', directories);

    return (
        <div>
            { data.length > 0 && 
                (<Select label="Storage Account" data={data.map(item => item.account)} value={selectedAccount} onChange={handleAccountChange} /> )
            }
            {
                directories.length > 0 && (
                    <Select label="Directory" data={directories} value={selectedDirectory} onChange={handleDirectoryChange} />
                )
            } 
        </div>
    )
}

export default SelectDirectoryComponent;
